(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["montal-base"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.MontalBase) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var revealObserver = null;

    function revealAll(root) {
      (root || document).querySelectorAll('[data-montal-reveal]').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    function observeReveal(root) {
      var scope = root || document;
      var items = scope.querySelectorAll('[data-montal-reveal]:not(.is-visible)');
      if (!items.length) return;

      if (
        reduceMotion.matches ||
        !('IntersectionObserver' in window) ||
        document.documentElement.classList.contains('shopify-design-mode')
      ) {
        revealAll(scope);
        return;
      }

      if (!revealObserver) {
        revealObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            });
          },
          { threshold: 0.1, rootMargin: '0px 0px -6% 0px' }
        );
      }

      items.forEach(function (el) {
        revealObserver.observe(el);
      });
    }

    function formatNumber(value) {
      return String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function animateCount(el, to, options) {
      options = options || {};
      var duration = options.duration || 500;
      var from = parseFloat(el.dataset.montalCurrent || 0);
      var start = performance.now();

      // En una pestaña de fondo requestAnimationFrame no corre: escribimos ya.
      if (reduceMotion.matches || document.hidden || Math.abs(to - from) < 1) {
        el.textContent = formatNumber(to);
        el.dataset.montalCurrent = to;
        return;
      }

      function frame(now) {
        var t = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - t, 3);
        el.textContent = formatNumber(from + (to - from) * eased);
        if (t < 1) {
          requestAnimationFrame(frame);
        } else {
          el.dataset.montalCurrent = to;
        }
      }
      requestAnimationFrame(frame);
    }

    window.MontalBase = {
      observeReveal: observeReveal,
      revealAll: revealAll,
      animateCount: animateCount,
      formatNumber: formatNumber,
    };

    function init() {
      document.body.classList.add('montal-page');
      observeReveal(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      observeReveal(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["montal-product-form"] && !Shopify.designMode) return;
  try {
    class MontalVariants extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const on = { signal: this.controller.signal };
      const data = this.querySelector('[data-montal-variants]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.idInput = this.querySelector('[data-variant-id]');
      this.addButton = this.querySelector('[data-add-button]');

      this.querySelectorAll('.montal-buy__radio').forEach((input) => {
        input.addEventListener('change', () => this.update(), on);
      });

      this.querySelectorAll('[data-qty]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const input = this.querySelector('[data-qty-input]');
          if (!input) return;
          const next = Math.max(1, (parseInt(input.value, 10) || 1) + Number(btn.dataset.qty));
          input.value = String(next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }, on);
      });

      this.markUnavailable();
    }

    disconnectedCallback() { this.controller?.abort(); }

    get selected() {
      const values = [];
      this.querySelectorAll('.montal-buy__radio:checked').forEach((input) => {
        values[Number(input.dataset.optionPosition) - 1] = input.value;
      });
      return values;
    }

    find(values) {
      return this.variants.find((v) =>
        values.every((val, i) => val === undefined || v.options[i] === val)
      );
    }

    update() {
      const variant = this.find(this.selected);
      this.markUnavailable();

      if (!variant) {
        this.setButton(null);
        return;
      }

      if (this.idInput) this.idInput.value = variant.id;
      this.setButton(variant);
      this.setPrice(variant);

      if (window.history?.replaceState && this.dataset.url) {
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${variant.id}`);
      }

      document.dispatchEvent(
        new CustomEvent('montal:variant:change', { detail: { variant, sid: this.dataset.sid } })
      );
    }

    setButton(variant) {
      const btn = this.addButton;
      if (!btn) return;
      if (!variant) {
        btn.disabled = true;
        btn.textContent = btn.dataset.labelNone;
      } else if (!variant.available) {
        btn.disabled = true;
        btn.textContent = btn.dataset.labelSold;
      } else {
        btn.disabled = false;
        btn.textContent = btn.dataset.labelAdd;
      }
    }

    setPrice(variant) {
      const format = (cents) => {
        if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
        return '$' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      };

      document.querySelectorAll('[data-montal-price]').forEach((root) => {
        const now = root.querySelector('[data-price]');
        const was = root.querySelector('[data-compare]');
        const save = root.querySelector('[data-save]');
        const discounted = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (now) now.textContent = format(variant.price);
        if (was) {
          was.hidden = !discounted;
          if (discounted) was.textContent = format(variant.compare_at_price);
        }
        if (save) {
          save.hidden = !discounted;
          if (discounted) save.textContent = 'Ahorras ' + format(variant.compare_at_price - variant.price);
        }
      });
    }

    /* Tacha los valores que no dan ninguna combinación comprable */
    markUnavailable() {
      const chosen = this.selected;
      this.querySelectorAll('.montal-buy__radio').forEach((input) => {
        const position = Number(input.dataset.optionPosition) - 1;
        const probe = chosen.slice();
        probe[position] = input.value;
        const match = this.variants.find((v) =>
          probe.every((val, i) => val === undefined || v.options[i] === val)
        );
        const label = input.nextElementSibling;
        if (label) label.classList.toggle('is-unavailable', !match || !match.available);
      });
    }
  }

  if (!customElements.get('montal-variants')) {
    customElements.define('montal-variants', MontalVariants);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["montal-product-gallery"] && !Shopify.designMode) return;
  try {
    class MontalGallery extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const on = { signal: this.controller.signal };
      this.track = this.querySelector('.montal-gallery__track');
      this.slides = Array.from(this.querySelectorAll('.montal-gallery__slide'));
      this.thumbs = Array.from(this.querySelectorAll('.montal-gallery__thumb'));
      this.counter = this.querySelector('[data-current]');
      this.dialog = this.querySelector('.montal-gallery__dialog');
      this.zoomWrap = this.querySelector('.montal-gallery__zoomwrap');
      this.index = 0;
      if (!this.track) return;

      this.querySelectorAll('.montal-gallery__arrow').forEach((btn) => {
        btn.addEventListener('click', () => this.go(this.index + Number(btn.dataset.dir)), on);
      });

      this.thumbs.forEach((btn) => {
        btn.addEventListener('click', () => this.go(Number(btn.dataset.goto)), on);
      });

      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
      }, on);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.setActive(Number(entry.target.dataset.index));
            });
          },
          { root: this.track, threshold: 0.6 }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));
      }

      if (this.dataset.lightbox !== 'false' && this.dialog) {
        this.querySelectorAll('.montal-gallery__open').forEach((btn) => {
          btn.addEventListener('click', () => this.open(Number(btn.dataset.index)), on);
        });
        this.querySelector('.montal-gallery__close')?.addEventListener('click', () => this.dialog.close(), on);
        this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); }, on);
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }

    go(i) {
      const next = Math.max(0, Math.min(this.slides.length - 1, i));
      const slide = this.slides[next];
      if (!slide) return;
      this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      this.setActive(next);
    }

    setActive(i) {
      this.index = i;
      if (this.counter) this.counter.textContent = String(i + 1);
      this.thumbs.forEach((btn, n) => {
        const active = n === i;
        btn.classList.toggle('is-active', active);
        if (active) { btn.setAttribute('aria-current', 'true'); } else { btn.removeAttribute('aria-current'); }
      });
    }

    open(i) {
      const img = this.slides[i]?.querySelector('img');
      if (!img || !this.zoomWrap || !this.dialog) return;
      const big = document.createElement('img');
      big.className = 'montal-gallery__zoom';
      big.src = img.currentSrc || img.src;
      big.alt = img.alt || '';
      big.width = img.naturalWidth || 1200;
      big.height = img.naturalHeight || 1500;
      this.zoomWrap.replaceChildren(big);
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
    }
  }

  if (!customElements.get('montal-gallery')) {
    customElements.define('montal-gallery', MontalGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
